var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 4.27a1.25 1.25 0 00-1.25 1.25v8.424a.208.208 0 01-.207.209H2.9a.833.833 0 00-.714 1.264l2.5 4.166a.833.833 0 001.429 0l2.5-4.166a.833.833 0 00-.715-1.262H6.859a.208.208 0 01-.208-.208V5.52A1.25 1.25 0 005.4 4.27zm9.2 11.43a1.25 1.25 0 001.25-1.25V6.028a.208.208 0 01.207-.209H17.1a.833.833 0 00.714-1.262L15.313.39a.867.867 0 00-1.429 0l-2.5 4.167a.833.833 0 00.715 1.262h1.042a.208.208 0 01.208.209v8.422a1.25 1.25 0 001.25 1.25z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.d153385d.svg";
export { ForwardRef as ReactComponent };